import React, { Component } from 'react';
import {CommentIcon} from '../shared/icons'
import { commentResult } from './styles';

export class CommentResult extends Component {

  state = {
    open: false
  };

  handleOpen = () => this.setState({open: true});

  handleClose = () => this.setState({open: false});

  onTouchTap = () => this.props.modal.props.isLoggedIn ?
    this.handleOpen() : this.props.modal.handleTouchTap();

  render() {
    return (
      <span className="comment" style={{cursor: 'pointer'}}>
        <CommentIcon
          height={18}
          onClick={this.onTouchTap}
        />
        { this.props.modal.props.numberOfComments &&
          <span style={commentResult.numOfCommentsWrap}>
            {this.props.modal.props.numberOfComments}
          </span>
        }
      </span>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./components/control/CommentResult.js
 **/